/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Progress_Phase_QueuedInputs */

const cs_import_progress_phase_queued = /** @type {(inputs: Import_Progress_Phase_QueuedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ve frontě`)
};

const en_import_progress_phase_queued = /** @type {(inputs: Import_Progress_Phase_QueuedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Queued`)
};

/**
* | output |
* | --- |
* | "Queued" |
*
* @param {Import_Progress_Phase_QueuedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_progress_phase_queued = /** @type {((inputs?: Import_Progress_Phase_QueuedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Progress_Phase_QueuedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_progress_phase_queued(inputs)
	return cs_import_progress_phase_queued(inputs)
});